import { ImageLoaderCSSStyleImpl } from 'src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss';

export class ToneCardImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl {
    getImgCSSStyle(): object {
        return {
            objectFit: 'cover',
            width: '100%',
            height: '250px',
            borderRadius: "50px 0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/tonecard/tonecardimageloadercss.tsx